import StockoutReceiverSearch from "./stockoutReceiverSearch.container"

export default StockoutReceiverSearch;